import React, { ReactNode, useState } from "react";
import "./FlushAccordian.css"

interface IFlushAccordian {
    title: string;
    titleImage?: string;
    titleImageWidth?: string;
    children: ReactNode;
    id: string;
    defaultOpen?: boolean; 
    marginLeftImage?: string;
    marginRightImage?: string;
}

const FlushAccordian: React.FC<IFlushAccordian> = ({ title, titleImage, titleImageWidth, children, id, defaultOpen = true, marginLeftImage, marginRightImage }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    return (
        <>
            <div className="accordion accordion-flush mt-3" id={`accordionFlushExample${id}`}>
                <div className="accordion-item">
                    <h2 className="accordion-header" id={`flush-headingOne${id}`}>
                        <button
                            className={`accordion-button ${isOpen ? "" : "collapsed"}`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#flush-collapseOne${id}`}
                            aria-expanded={isOpen ? "true" : "false"}
                            aria-controls={`flush-collapseOne${id}`}
                            style={{ paddingRight: '30px', paddingLeft: '8px' }}
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            {
                                (titleImage!==undefined && titleImage!=null && titleImage!=="") ? <img src={titleImage} alt="titleImage" style={{marginRight: marginRightImage, width: titleImageWidth, marginLeft: marginLeftImage}}/> : <></>
                            }
                            {title}
                        </button>
                    </h2>
                    <div
                        id={`flush-collapseOne${id}`}
                        className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
                        aria-labelledby={`flush-headingOne${id}`}
                        data-bs-parent={`#accordionFlushExample${id}`}
                    >
                        <div className="accordion-body mb-3">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FlushAccordian;
